import { DOT_SHAPE, SHAPE_SPAN_CLASS } from "src/blitz/Charts/constants"

const Shape = (props) => {
  const { color, shape = DOT_SHAPE, dataTestid = undefined } = props
  return (
    <div
      data-testid={dataTestid}
      style={{ color: color }}
      className={SHAPE_SPAN_CLASS[shape]}
    ></div>
  )
}

export default Shape
